import { render, staticRenderFns } from "./newAccount.vue?vue&type=template&id=74604a83&scoped=true"
import script from "./newAccount.vue?vue&type=script&lang=js"
export * from "./newAccount.vue?vue&type=script&lang=js"
import style0 from "./newAccount.vue?vue&type=style&index=0&id=74604a83&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74604a83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74604a83')) {
      api.createRecord('74604a83', component.options)
    } else {
      api.reload('74604a83', component.options)
    }
    module.hot.accept("./newAccount.vue?vue&type=template&id=74604a83&scoped=true", function () {
      api.rerender('74604a83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/children/newAccount.vue"
export default component.exports